module.exports = __webpack_public_path__ + "img/magento-custom-development.24f39ed8.jpeg";